import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useMemo } from 'react';

import { getContext } from '../../../../../selectors/pageSelectors';

export const useIsQBooksAccountReadonly = () => {
    const context = useSelector(getContext);

    return useMemo(() => {
        const qBooksItemField = context.fields.find(
            (field) => field.systemPurpose === domain.FieldSystemPurpose.QBooksAccount
        );

        return Boolean(qBooksItemField && context.readonlyFieldIds.includes(qBooksItemField.id));
    }, [context.fields, context.readonlyFieldIds]);
};
